module.exports = __webpack_public_path__ + "img/stock4.1dd2cf92.png";